import { DOCUMENT } from '@angular/common';
import { Injectable, afterNextRender, inject } from '@angular/core';
import { environment } from '@awread/global/environments';

/**
 * Analytics đã chuyển từ Plausible (p.awread.vn, đã bỏ) sang Rybbit (rybbit.losan.ai).
 * Script Rybbit nhúng ở apps/reader/web/src/index.html và tự đếm pageview,
 * service này chỉ còn chuyển custom event sang `window.rybbit.event`.
 * Giữ tên PlausibleService để không phải sửa các nơi đang gọi.
 */
@Injectable({
  providedIn: 'root',
})
export class PlausibleService {
  document = inject(DOCUMENT);

  enableAutoPageviews = () => {};
  trackEvent = (eventName: any, options?: any, eventData?: any) => {};
  trackPageview = (eventData?: any, options?: any) => {};

  start() {
    if (environment.production) {
      afterNextRender(() => {
        this.trackEvent = (eventName: string, options?: { props?: Record<string, any> }) => {
          (this.document.defaultView as any)?.rybbit?.event(eventName, options?.props);
        };
      });
    }
  }
}
